module.exports = __webpack_public_path__ + "img/spouse.91ad6d3c.svg";